import Vuex, {
  MutationTree,
  GetterTree,
  ActionTree,
  Module,
} from 'vuex'
import Vue from 'vue'
import { IIntroWithoutThemeAndForms, ISectionWithoutThemeAndForms } from '@/types'
import { RootState } from '..'

Vue.use(Vuex)

export interface PageModulesState {
  homeIntros: IIntroWithoutThemeAndForms[];
  homePage: ISectionWithoutThemeAndForms[];
  spotifyConnectPage: ISectionWithoutThemeAndForms[];
  successIntros: IIntroWithoutThemeAndForms[];
  successPage: ISectionWithoutThemeAndForms[];
  successOptIntros: IIntroWithoutThemeAndForms[];
  successOptPage: ISectionWithoutThemeAndForms[];
  endIntros: IIntroWithoutThemeAndForms[];
  endPage: ISectionWithoutThemeAndForms[];
}

export const pageModulesState: PageModulesState = {
  homeIntros: [],
  homePage: [],
  spotifyConnectPage: [],
  successIntros: [],
  successPage: [],
  successOptIntros: [],
  successOptPage: [],
  endIntros: [],
  endPage: [],
}

const pageModulesMutations: MutationTree<PageModulesState> = {
  SET_HOME_INTROS (
    state: PageModulesState,
    modules: IIntroWithoutThemeAndForms[]
  ) {
    state.homeIntros = modules
  },
  SET_HOME_PAGE_MODULES (
    state: PageModulesState,
    modules: ISectionWithoutThemeAndForms[]
  ) {
    state.homePage = modules
  },
  SET_SPOTIFY_CONNECT_PAGE_MODULES (
    state: PageModulesState,
    modules: ISectionWithoutThemeAndForms[]
  ) {
    state.spotifyConnectPage = modules
  },
  SET_SUCCESS_INTROS (
    state: PageModulesState,
    modules: IIntroWithoutThemeAndForms[]
  ) {
    state.successIntros = modules
  },
  SET_SUCCESS_PAGE_MODULES (
    state: PageModulesState,
    modules: ISectionWithoutThemeAndForms[]
  ) {
    state.successPage = modules
  },
  SET_SUCCESS_OPT_INTROS (
    state: PageModulesState,
    modules: IIntroWithoutThemeAndForms[]
  ) {
    state.successOptIntros = modules
  },
  SET_SUCCESS_OPT_PAGE_MODULES (
    state: PageModulesState,
    modules: ISectionWithoutThemeAndForms[]
  ) {
    state.successOptPage = modules
  },
  SET_END_INTROS (
    state: PageModulesState,
    modules: IIntroWithoutThemeAndForms[]
  ) {
    state.endIntros = modules
  },
  SET_END_PAGE_MODULES (
    state: PageModulesState,
    modules: ISectionWithoutThemeAndForms[]
  ) {
    state.endPage = modules
  },
}

const pageModulesActions: ActionTree<PageModulesState, RootState> = {
}

const pageModulesGetters: GetterTree<PageModulesState, RootState> = {
  pageModulesHomeIntros: (state: PageModulesState) => state.homeIntros,
  pageModulesHome: (state: PageModulesState) => state.homePage,
  pageModulesSpotifyConnect: (state: PageModulesState) => state.spotifyConnectPage,
  pageModulesSuccessIntros: (state: PageModulesState) => state.successIntros,
  pageModulesSuccess: (state: PageModulesState) => state.successPage,
  pageModulesSuccessOptIntros: (state: PageModulesState) => state.successOptIntros,
  pageModulesSuccessOpt: (state: PageModulesState) => state.successOptPage,
  pageModulesEndIntros: (state: PageModulesState) => state.endIntros,
  pageModulesEnd: (state: PageModulesState) => state.endPage,
  // Helper getters to check if legacy page-specific intros exist
  hasLegacySuccessIntros: (state: PageModulesState) => state.successIntros.length > 0,
  hasLegacySuccessOptIntros: (state: PageModulesState) => state.successOptIntros.length > 0,
  hasLegacyEndIntros: (state: PageModulesState) => state.endIntros.length > 0,
  // Effective intros: returns page-specific intros if legacy exists, otherwise falls back to homeIntros
  effectiveSuccessIntros: (state: PageModulesState) =>
    state.successIntros.length > 0 ? state.successIntros : state.homeIntros,
  effectiveSuccessOptIntros: (state: PageModulesState) =>
    state.successOptIntros.length > 0 ? state.successOptIntros : state.homeIntros,
  effectiveEndIntros: (state: PageModulesState) =>
    state.endIntros.length > 0 ? state.endIntros : state.homeIntros,
}

export const pageModulesModule: Module<PageModulesState, RootState> = {
  state: pageModulesState,
  mutations: pageModulesMutations,
  getters: pageModulesGetters,
  actions: pageModulesActions,
}
